"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_EXPIRED_MODELS } from "api";
import { UseExpiredModelsParams } from "types";

// Helper: convert Date/string to UTC ISO string with 00:00 time
const toDateStringOnly = (date: string | Date): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};


// Fetcher
const fetchExpiredModels = async (params: UseExpiredModelsParams) => {
  const url = GET_EXPIRED_MODELS(
    toDateStringOnly(params.startDate),
    toDateStringOnly(params.endDate)
  );
  const response = await fetch(url);

  // Map _id → id for frontend compatibility
  const fixedModels = response.models.map((model: any) => ({
    ...model,
    id: model._id,
  }));

  return {
    ...response,
    models: fixedModels,
  };
};

// Hook
export const useGetExpiredModels = (params: UseExpiredModelsParams) => {
  return useQuery({
    queryKey: ["expiredModels", params],
    queryFn: () => fetchExpiredModels(params),
    staleTime: 10000,
    enabled: !!params.startDate && !!params.endDate,
  });
};

export default useGetExpiredModels;
